import { render, staticRenderFns } from "./fish.vue?vue&type=template&id=5091bb28"
import script from "./fish.vue?vue&type=script&lang=js"
export * from "./fish.vue?vue&type=script&lang=js"
import style0 from "./fish.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/fish.vue
// module id = /wVm
// module chunks = 0